import {Checkboxes, Fieldset} from "nhsuk-react-components"
import ProductSummaryList from "./productSummaryList"
import {FieldArray, FormikProps, getIn} from "formik"
import EndorsementArray from "./endorsementArray"
import * as React from "react"
import {ProductFormValues} from "./claimForm"

interface ProductProps {
  name: string
  product: ProductFormValues
  form: FormikProps<any>
}

const Product: React.FC<ProductProps> = ({
  name,
  product,
  form
}) => (
  <Fieldset>
    <Fieldset.Legend size="m">{product.name}</Fieldset.Legend>
    <ProductSummaryList {...product} />
    <Checkboxes id={`${name}.patientPaid.boxes`}>
      <Checkboxes.Item
        id={`${name}.patientPaid.box`}
        name={`${name}.patientPaid`}
        type="checkbox"
        checked={!!getIn(form.values, `${name}.patientPaid`)}
        onChange={form.handleChange}
        onBlur={form.handleBlur}>
        Patient Paid
      </Checkboxes.Item>
    </Checkboxes>
    <FieldArray name={`${name}.endorsements`} component={EndorsementArray} />
  </Fieldset>
)

export default Product
